import { endpoints } from "@app/api/apis";
import PledgeIconNew from "@app/assets/svg/PledgeIconNew";
import handleApiErr from "@app/helper/handleApiErr";
import { getNextRoute } from "@app/navigationApp/navigationUtil";
import ROUTE from "@app/navigationApp/routes";
import { getApplicationId } from "@app/screens/FetchPortfolio/utils";
import Button from "@app/sharedComponents/Button/Button";
import { useAppDispatch } from "@app/store/hooks";
import { RootState } from "@app/store/newstore";
import { showErrorSheet } from "@app/store/slices/errorSlice";
import { Theme, ThemedText, ThemedView } from "@app/theme";
import { addCommasToNumber, getDateMonthYearFromEpochFromMicroseconds } from "@app/utils";
import { useTheme } from "@shopify/restyle";
import axios from "axios";
import { useState } from "react";
import { Image } from "react-native"
import { useSelector } from "react-redux";
const IMAGE1 = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/pledge_assets.png'
const PostFetchView = ({
    route,
    navigation,
    pledgeData,
    currentApplicationDetails
}: {
    route: any;
    navigation: any;
    pledgeData: any;
    currentApplicationDetails: any;
}) => {
    const [btnLoading, setBtnLoading] = useState(false);
    const {userDetails} = useSelector((state: RootState) => state.auth);
    const dispatch = useAppDispatch();
    const { colors } = useTheme<Theme>();
    
    const applicationStage = currentApplicationDetails?.applicationStage;
    const approvedCreditLimit = pledgeData?.stepResponseObject?.additionalLimit
    const availableToUnlock = pledgeData?.stepResponseObject?.availableCreditLimit

    let dateToPick = 0
    const karvyFetchDate = pledgeData?.stepResponseObject?.repositoryAssetMetadataMap?.KARVY?.casFetchDate;
    const camsFetchDate = pledgeData?.stepResponseObject?.repositoryAssetMetadataMap?.CAMS?.casFetchDate;
    if (karvyFetchDate === null) { dateToPick = camsFetchDate} 
    else if (camsFetchDate === null) { dateToPick = karvyFetchDate} 
    else {dateToPick = Math.max(karvyFetchDate, camsFetchDate)}
    let date = dateToPick === null ? '' : getDateMonthYearFromEpochFromMicroseconds(dateToPick);

    const handleIncreaseLimit = async() => {
        setBtnLoading(true)
        try {
            const applicationId = await getApplicationId(userDetails?.linkedApplications[0]?.applicationId);
            const updatedApplicationResponse = await axios.get(`${endpoints.borrowerApplication}${applicationId}`);
            const currentStepId = updatedApplicationResponse.data.currentStepId;

            if(currentStepId === "MF_FETCH_PORTFOLIO" || currentStepId === "MF_PLEDGE_PORTFOLIO") {
                const enabledRTAFlowResponse = await axios.get(`${endpoints.checkEnabledRTA}${applicationId}`);
                const isFromMFCentral = enabledRTAFlowResponse?.data?.enabledRtaFlow === "MfCentralFlow";
                const mfcFetchStatus = enabledRTAFlowResponse?.data?.mfcFetchStatus
                if (mfcFetchStatus === "IN_PROGRESS") {
                    navigation.navigate(ROUTE.MFC_FETCH_EVALUTE_FUNDS)
                } else if (isFromMFCentral && currentStepId === ROUTE.MF_PLEDGE_PORTFOLIO) {
                    await navigation.navigate(ROUTE.MFC_FETCH_ANCHOR)
                } else if (isFromMFCentral && currentStepId === ROUTE.MF_FETCH_PORTFOLIO) {
                    await navigation.navigate(ROUTE.MF_FETCH_PORTFOLIO)
                }  else if (!isFromMFCentral) {
                    const route = await getNextRoute(currentStepId, updatedApplicationResponse.data.applicationState, updatedApplicationResponse.data.stepStatusMap);
                    await navigation.navigate(route);
                }
            } else {
                const route = await getNextRoute(currentStepId, updatedApplicationResponse.data.applicationState, updatedApplicationResponse.data.stepStatusMap);
                navigation.navigate(route);
            }
        } catch (err: any) {
            if (err?.data?.statusCode && handleApiErr(err)) {
                setBtnLoading(false);
                    dispatch(showErrorSheet({
                        isErrorSheetVisible: true,
                        errorMessage: err?.data?.message,
                        closeOnBackdropPress: true,
                        errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
                        errorHeading: err?.data?.header,
                        showErrorHeading: true,
                        btnName: 'Ok, got it!',
                    }))
                    return;
            }
        }
        setBtnLoading(false)
    }

    return (
        <ThemedView style={{ padding: 16, marginBottom: 16 }} backgroundColor={'bg-fill-primary'} borderBottomWidth={1} borderColor={'border-secondary'}>
            <ThemedText
                variant="h3s"
                color="text-primary"
            >
                Unlock additional credit limit
            </ThemedText>
            <ThemedText
                variant="b4r"
                color="text-secondary"
            >
                Last fetched on {date === null ? '' : date}
            </ThemedText>
            <ThemedView borderWidth={1} borderColor="border-secondary" borderRadius="md" style={{ marginTop: 16 }}>
                <ThemedView flexDirection="row" style={{ padding: 16 }}>
                    <ThemedView style={{ height: 52, width: 52, alignItems: 'center', justifyContent: 'center', backgroundColor: colors['bg-fill-emphasis-primary-1'], borderRadius: 8, marginRight: 12 }}>
                        <PledgeIconNew bgColor={colors['bg-fill-emphasis-primary-1']} color1={colors['icon-action-primary']} color2={colors['icon-emphasis-primary']} />
                    </ThemedView>
                    <ThemedView>
                        <ThemedText
                            variant="b3r"
                            color="text-secondary"
                        >
                            Available to unlock
                        </ThemedText>
                        <ThemedText
                            variant="b1b"
                            color="text-emphasis-secondary"
                            style={{ fontSize: 24 }}
                        >
                            ₹{applicationStage === "POST_PLEDGE" ? addCommasToNumber(approvedCreditLimit) : addCommasToNumber(availableToUnlock)}
                        </ThemedText>
                    </ThemedView>
                </ThemedView>
            </ThemedView>
            <ThemedView flexDirection="row" style={{ marginTop: 16}}>
                    <Button
                        eventName={route.name + '_GET_MY_PORTFOLIO'}
                        label={'Unlock limit'}
                        handlePress={() => {
                            handleIncreaseLimit()
                        }}
                        type={'SOLID'}
                        size='MD'
                        bg='bg-primary'
                        textColor='text-primary'
                        buttonLoader={btnLoading}
                    />
            </ThemedView>
        </ThemedView>
    )
}

export default PostFetchView;